import React, { useContext, useEffect, useState } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Sidebar from '../theme/Sidebar'
import Header from '../theme/Header'
import Auth from '../../auth/Auth';
import Footer from '../theme/Footer';
import { organizationList } from '../_slice/organizationSlice';
import { getStripeConnectionStatus, connectStripe } from '../_slice/paymentMethodSlice';
import AppContext from '../context/AppContext';

function DashboardLayout() {

  const [sideBarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const organizationData = useSelector((state) => state?.organization?.organizationData);

  // Fetch organization data on mount if not already loaded
  useEffect(() => {
    if (Auth.isUserAuthenticated() && (!organizationData || organizationData.length === 0)) {
      dispatch(organizationList({ setLoader, navigate }));
    }
  }, []);

  // Check Stripe connection status on mount and auto-connect if needed
  useEffect(() => {
    if (Auth.isUserAuthenticated()) {
      dispatch(getStripeConnectionStatus({ navigate, setLoader })).then((response) => {
        const payload = response?.payload;
        const isConnected = payload?.connected || payload?.is_connected;
        if (response?.type?.endsWith("/fulfilled") && !isConnected) {
          dispatch(connectStripe({ navigate, setLoader }));
        }
      });
    }
  }, []);

  // Adjust sidebar state on window resize
  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 768;
      setIsMobile(isNowMobile);
      if (isNowMobile) {
        setSidebarOpen(false); // Automatically close sidebar on mobile
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!Auth.isUserAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="body">
      <Sidebar sideBarOpen={sideBarOpen} setSidebarOpen={setSidebarOpen} isMobile={isMobile} />
      <div className={`main ${sideBarOpen || !isMobile ? '' : 'full_screen'}`}>
        <Header sideBarHandler={() => setSidebarOpen(!sideBarOpen)} isMobile={isMobile} />
        <div className="outer_common_layout">
          <Outlet />
        </div>
        {/* <Footer></Footer> */}
      </div>
    </div>
  )
}

export default DashboardLayout